import {
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
  TIContainerInformationExtendedValid,
} from "@tedivo/tedivo-bay-grid-pure";
import { BayLevelEnum } from "open-vessel-definition";

import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";
import { topContainersOfStack } from "./topContainersOfStack";

export function getContainersByHighestBelowOrLowestAbove(
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
): TGetContainersFilterOutput {
  const containers: TIContainerInformationExtendedValid[] = [];

  const { gridContent, allStacksKeys, allTiersKeys } = smartBay.getGridContent();

  // For each stack, get the highest container below deck or lowest above deck
  for (const stackKey of allStacksKeys) {
    containers.push(
      ...topContainersOfStack(
        smartBay,
        gridContent,
        stackKey,
        allTiersKeys,
        smartBay.level === BayLevelEnum.BELOW ? "highest" : "lowest",
      ),
    );
  }

  return {
    containers,
    tBaysStr: smartBay.tBaysStr,
    level: smartBay.level,
  };
}
